import { Card, CardContent, Grid, Typography } from '@mui/material';
import moment from 'moment';
import SubscriptionsAndEarningsCard from './subscriptionsAndEarningsGroupByMonth.tsx/SubscriptionsAndEarningsCard';

const SextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth = () => {
    const timezone = moment.tz.guess();

    return (
        <Card>
            <CardContent>
                <Grid container flexGrow={1} spacing={0} sx={{ marginBottom: 1 }}>
                    <Grid item xs={12}>
                        <Typography variant="h5" sx={{ marginBottom: 1 }}>
                            New Subscriptions and Earnings by Month
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                            See the number of <strong>new subscriptions</strong> each month, and how much you've earned from these new fans
                            since they subscribed (net). This does not include resubscriptions or those who rebilled.
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container flexGrow={1} spacing={0} sx={{ padding: 0 }}>
                    <Grid item xs={12}>
                        <SubscriptionsAndEarningsCard timezone={timezone} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth;
